import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;

export default class ScanPrompt extends Component {
  componentDidMount(){
    this.scanInput.focus();
    // THIS FEELS A BIT HACKY
    window.addEventListener('click', this.pageClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.pageClick, false);
  }

  // FORCE INPUT FOCUS
  pageClick = () => {
    this.scanInput.focus();
  }

  // FORCE INPUT FOCUS
  onChange = (event) => {
    if(!isAndroid) return;
    if(event.target.value) {
      this.props.handleScan(event.target.value);
      event.target.value = "";
    }
  }

  // FORCE INPUT FOCUS
  onKeyPress = (event) => {
    if(isAndroid) return;
    if(event.target.value && event.key === 'Enter') {
      this.props.handleScan(event.target.value);
      event.target.value = "";
    }
  }

  render() {
    const { type } = this.props;
    const getTitle = (type) => {
      switch(type) {
        case 'picking':
          return <p>Obi Wan Kenobi Wan, scan either <strong>ASN ID</strong> or <strong>Zone Code</strong> to start</p>;
        case 'totePicking':
          return <p>Please scan the <strong>Tote ID</strong> to proceed and start picking items</p>;
        case 'totePutting':
          return <p>Please scan the <strong>Tote ID</strong> to proceed and start putting items away</p>;
        case 'location':
          return <p>Young Jedi, you need to <strong>scan your location</strong> before you can start</p>;
        case 'itemRemoval':
          return <p>Young Jedi, you need to rescan this item to <strong>remove</strong> it from this picking session</p>;
        default:
          return null;
      }
    }
    const visuallyHidden = type === 'pickingSession';

    return (
      <div className={`${styles.scanPrompt} ${styles[type]} `}>
          <input
            type="text"
            onKeyPress={this.onKeyPress}
            onChange={this.onChange}
            ref={(input) => { this.scanInput = input; }}
          />
          {!visuallyHidden && <div>
            {getTitle(type)}
            <i className="icon-barcode" />
          </div>}
      </div>
    );
  }
}

ScanPrompt.propTypes = {
  type: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/common/ScanPrompt/index.js